import { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import { ResetPasswordRequest } from 'orderme-api-integration-client';
import { CustomerClient } from '../../../helpers/client';
import { Popup } from '../../popup/popup';
import { DialogProps } from '../../../interfaces/interfaces';
import { useTranslation } from 'react-i18next';
import { isValidEmail, isValidPhoneNumber, normalizePhone } from '../../../helpers/validator';

export function ResetPassword(props: DialogProps) {
  const customersClient: CustomerClient = new CustomerClient();
  const [inputValue, setInputValue] = useState('');
  const [success, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const { onClose, open } = props;

  const { t } = useTranslation();

  const isButtonDisabled = !isValidEmail(inputValue) && !isValidPhoneNumber(inputValue);

  const resetPassword = async () => {
    setSuccess(false);
    setFailure(false);

    const email = isValidEmail(inputValue) ? inputValue : null;
    const phone = !email ? normalizePhone(inputValue) : null;
    await new Promise((resolve) => setTimeout(resolve, 2000));
    try {
      await customersClient.resetPassword(new ResetPasswordRequest({ email, phone }));

      setInputValue('');
      setSuccess(true);
      setTimeout(function () {
        handleClose();
      }, 3000);
    } catch (err) {
      setFailure(true);
      console.log(err);
    }
  };

  const handleClose = () => {
    setSuccess(false);
    setFailure(false);
    setInputValue('');
    onClose();
  };

  return (
    <Popup
      submitOnEnter
      open={open}
      onClose={() => handleClose()}
      dialogTitle={t('account:resetPasswordTitle')}
      dialogContent={
        <>
          <Typography sx={{ pb: '20px', fontSize: '18px' }}>{t('account:enterPhoneOrEmail')}</Typography>
          <TextField
            fullWidth
            sx={{ mb: '15px' }}
            slotProps={{
              input: {
                sx: {
                  borderRadius: '10px',
                },
              },
            }}
            onChange={(e) => setInputValue(e.target.value.trim())}
            label={t('account:loginInput')}
            variant="outlined"
            autoFocus
          />
        </>
      }
      onAction={resetPassword}
      buttonContent={t('account:resetPassword')}
      isButtonDisabled={isButtonDisabled}
      isSuccess={success}
      successText={t('account:tempPasswordSent')}
      isFailure={failure}
      failureText={t('errors:userNotFound')}
    />
  );
}
